export enum Methods {
  ProvideETHLiquidity = 'provideETHLiquidity',
  ProvideTokensLiquidity = 'provideTokensLiquidity',
  ProvideBUSDLiquidity = 'provideBUSDLiquidity'
}
